import styled from "styled-components";
import tw from "twin.macro";
import { Theme } from "../../context";

export const RightCustomerContainer = styled.div<{ rooTheme?: Theme }>`
  ${tw`max-w-[100vw] mx-auto lg:px-20 py-5 lg:py-10`}

  @media screen and (max-width:1024px) {
    width: calc(100vw - 100px);
  }

  @media screen and (max-width: 768px) {
    width: calc(100vw);
  }

  @media screen and (max-width: 500px) {
    width: calc(100vw);
  }
  ${({ rooTheme }) =>
    rooTheme !== "dark" ? tw`z-50 bg-basebackground` : tw`z-50 bg-white`}

  // @media screen and (max-width: 1024px) {
  //   ${tw`z-10 pt-14 `}
  // }
  @media screen and (max-width: 768px) {
    ${tw`px-[70px] z-50`}
  }
  @media screen and (max-width: 500px) {
    ${tw`px-[50px] z-50`}
  }
`;

export const JiffyContainer = styled.div`
  ${tw`flex flex-col text-white lg:flex-row lg:justify-between lg:items-center lg:pb-20 font-clash`}
`;

export const JiffyContent = styled.div`
  ${tw`text-center lg:py-5 lg:text-start`}
`;

export const ImageContainer = styled.div`
  ${tw`flex items-center justify-center py-5`}

  >div {
    ${tw`w-full md:w-[50%] lg:w-full`}
  }
`;

export const JiffyButtonContainer = styled.div`
  ${tw`flex items-center justify-center py-5 lg:justify-start`}
`;
